import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';
import { withRouter } from 'react-router';
import './ComponentsStylesheet.css';

const { SubMenu } = Menu;

const Component = withRouter(props => {
    const { onCollapsePressed } = props;
    const [collapsedState, setCollapsedState] = useState(false);
    const [location, setLoction] = useState(props.location.pathname);
    const [openSubMenus, setOpenSubMenus] = useState([]);

    const pathPrefix =
        '/' +
        location
            .split('/')
            .splice(1, 1)
            .toString();

    useEffect(() => {
        setLoction(props.location.pathname);
        setOpenSubMenus(getDefaultOpenSubMenusKeys());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.pathname, setLoction]);

    const handleOpenSubMenuChanged = newKeys => {
        setOpenSubMenus(newKeys);
    };
    const getCurrentPageTreeLeaf = () => {
        let pathArr = location.split('/').filter(part => part !== '');

        if (pathPrefix === '/edit' || pathPrefix === '/view') {
            pathArr.shift();
        }

        return '/' + pathArr.join('/');
    };
    const getDefaultOpenSubMenusKeys = () => {
        let pathArr = props.location.pathname.split('/').filter(part => part !== '');

        if (pathPrefix === '/edit' || pathPrefix === '/view') {
            pathArr.shift();
        }

        let currentPath = '';
        return pathArr.map(path => {
            currentPath += '/' + path;
            return currentPath;
        });
    };

    const toggleCollapseMenu = () => {
        let newCollapsedState = !collapsedState;
        setCollapsedState(newCollapsedState);
        onCollapsePressed && onCollapsePressed(newCollapsedState);
    };

    const createPageMenu = (page, level = 0) => {
        const subPageKeys = page.subpages ? Object.keys(page.subpages) : [];
        subPageKeys.sort( 
            (a, b) => (
                (page.subpages[a].order !== undefined ? page.subpages[a].order : Number.MAX_VALUE)
                - (page.subpages[b].order !== undefined? page.subpages[b].order : Number.MAX_VALUE)
            )
        );

        if (!page.showInMenu) {
            return null;
        }

        const linkTo = pathPrefix === '/edit' || pathPrefix === '/view' ? pathPrefix + page.path : page.path;

        if (subPageKeys.length === 0 || !subPageKeys.find(subPageKey => page.subpages[subPageKey].showInMenu)) {
            //No subpages
            return (
                <Menu.Item key={page.path} className="menu-item menu-item--last" title={page.description}>
                    <span>
                        <Icon type="file-text" style={{ fontSize: '1.25em' }} />
                        <span><Link to={linkTo}>{page.title}</Link></span>
                    </span>
                </Menu.Item>
            );
        } else {
            //Has subpages
            return (
                <SubMenu
                    key={page.path}
                    className="menu-sub"
                    title={
                        <span >
                            <Icon type="folder" style={{ fontSize: '1.25em' }} />
                            <span><Link to={linkTo}>{page.title}</Link></ span>
                        </span>
                    }
                    children={subPageKeys.map(subPageKey => {
                        return createPageMenu(page.subpages[subPageKey], level + 1);
                    })}
                />
            );
        }
    };

    return (
        <React.Fragment>
            <span type="primary" onClick={toggleCollapseMenu} className="nav-collapse">
                <Icon type={collapsedState ? 'menu-unfold' : 'menu-fold'} />
                {collapsedState ? '' : ' Collapse'}
            </span>
            <Menu mode="inline" theme="dark" selectedKeys={[getCurrentPageTreeLeaf()]} openKeys={collapsedState ? [] : openSubMenus} onOpenChange={handleOpenSubMenuChanged}>
                {props.pages.sort( (a, b) => (a.order !== undefined ? a.order : Number.MAX_VALUE) - (b.order !== undefined? b.order : Number.MAX_VALUE)).map(createPageMenu)}
            </Menu>
        </React.Fragment>
    );
});

const mapStateToComponentProps = state => ({
    pages: state.pages.pages
});

//Export
const ConnectedComponent = connect(
    mapStateToComponentProps,
    null
)(Component);

export { ConnectedComponent as Component };
